// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__9ttVX","rotation":"SmallLoader_rotation__p-DRJ"};